module.exports = __webpack_public_path__ + "media/m-taku-Komorebi-ChunYinYue.1c5c4636.mp3";